import { render, staticRenderFns } from "./CodeBlock.vue?vue&type=template&id=f3f1f116"
import script from "./CodeBlock.vue?vue&type=script&lang=js"
export * from "./CodeBlock.vue?vue&type=script&lang=js"
import style0 from "./CodeBlock.vue?vue&type=style&index=0&id=f3f1f116&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports